'use client'

import { Box, Stack } from "@mui/material";
import { useTranslations } from "next-intl";
import dynamic from "next/dynamic";
const Image = dynamic(() => import('@/components/common/image'), { ssr: false });
import '@/components/styles/consultation/session_details.css';
import React, {useEffect} from "react";
import Cookies from "js-cookie";
import {useSearchParams} from "next/navigation";
import {Rfs__consultation} from "../../../../../../_refs/Rfs__consultation";

export default function Page() {
    const t = useTranslations('consultation.session_detail_card');
    const [lang, setLang] = React.useState('en');
    const [type, setType] = React.useState('group');
    const searchParams = useSearchParams();
    const session_options = [
        { text: `${(type == 'individual'?'30':'60')} ${t('session_options.nMinutes')}`, icon: '/icons/Clock copy.svg' },
    ];
    /*if(type != 'individual'){
        session_options.push({ text: t('session_options.Free'), icon: '/icons/Money Off.svg' });
    }*/
    session_options.push({ text: t('session_options.Google Meet Session'), icon: '/icons/Meet Now.svg' });

    const desc = t.raw('description');


    useEffect(()=>{
      const sp = searchParams as any;
      if (!sp) return;
      const lang = Cookies.get('language') || 'en';
      setLang(lang);
      const typeParam = sp.get('type');
      if(typeParam && typeParam != type){
        setType(typeParam);
      }
    },[])

    Rfs__consultation.sidebar_consultation();

    return <Box
        sx={{
            backgroundColor: 'white',
        }}
        paddingY={6}
        paddingX={4}
        borderRadius={'12px'}
        minHeight={'610px'}
    >
        <h2>{t('title')}</h2>

        <Image
            alt="divider"
            url="/divider.svg"
            className="w-full mt-4 mb-8"
        />

        <h6 className="text-darkText">
          {
            lang == 'fa'?
              <ul className={'sop-can-apply'}>
                {
                  desc ? desc.map((itemStr:string) =>
                      {
                        const itemArr = itemStr.split('||')
                        return <li key={itemArr[0]}>
                          <span>{itemArr[0]}</span>
                          <span>{itemArr[1]}</span>
                        </li>
                      }
                    )
                    :
                  ''
                }
              </ul>
              :
              desc && desc[0] || ''
          }
        </h6>

        <Stack
            marginTop={5}
            spacing={3}
            useFlexGap
            direction={'column'}
        >
            {
                session_options.map((item: { text: string, icon: string }) => <Stack
                    key={item.text}
                    gap={'12px'}
                    direction={'row'}
                    alignItems={'center'}
                >
                    <Image
                        alt={`${item.text} icon`}
                        url={item.icon}
                        className="w-6"
                    />
                    <h6> {item.text}</h6>
                </Stack>
                )
            }

        </Stack>

    </Box>
};
